var __jsx = React.createElement;
import React from "react";
import { jsx as ___EmotionJSX } from "@emotion/core";
const Israel = () => {
  return ___EmotionJSX("svg", {
    fill: "none",
    height: "15",
    viewBox: "0 0 20 15",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg"
  }, ___EmotionJSX("mask", {
    height: "15",
    id: "mask0_305_22428",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    },
    width: "20",
    x: "0",
    y: "0"
  }, ___EmotionJSX("rect", {
    fill: "white",
    height: "14",
    stroke: "white",
    width: "19",
    x: "0.5",
    y: "0.5"
  })), ___EmotionJSX("g", {
    mask: "url(#mask0_305_22428)"
  }, ___EmotionJSX("path", {
    clipRule: "evenodd",
    d: "M0 0V15H20V0H0Z",
    fill: "#F7FCFF",
    fillRule: "evenodd"
  }), ___EmotionJSX("mask", {
    height: "15",
    id: "mask1_305_22428",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    },
    width: "20",
    x: "0",
    y: "0"
  }, ___EmotionJSX("path", {
    clipRule: "evenodd",
    d: "M0 0V15H20V0H0Z",
    fill: "white",
    fillRule: "evenodd"
  })), ___EmotionJSX("g", {
    mask: "url(#mask1_305_22428)"
  }, ___EmotionJSX("path", {
    clipRule: "evenodd",
    d: "M0 2.5V4.72843H20V2.5H0Z",
    fill: "#3D58DB",
    fillRule: "evenodd"
  }), ___EmotionJSX("path", {
    clipRule: "evenodd",
    d: "M0 10.2175V12.5H20V10.2175H0Z",
    fill: "#3D58DB",
    fillRule: "evenodd"
  }), ___EmotionJSX("path", {
    clipRule: "evenodd",
    d: "M7.11325 9.33678H12.9739L10.0724 4.32397L7.11325 9.33678ZM11.7816 8.64927H8.31746L10.0666 5.68628L11.7816 8.64927Z",
    fill: "#3D58DB",
    fillRule: "evenodd"
  }), ___EmotionJSX("path", {
    clipRule: "evenodd",
    d: "M6.93222 5.57828H12.9255L10.0849 10.6068L6.93222 5.57828ZM11.7475 6.26578H8.1747L10.0541 9.26347L11.7475 6.26578Z",
    fill: "#3D58DB",
    fillRule: "evenodd"
  }))), ___EmotionJSX("path", {
    d: "M1 1H19V-1H1V1ZM19 1V14H21V1H19ZM19 14H1V16H19V14ZM1 14V1H-1V14H1ZM1 14H1H-1C-1 15.1046 -0.104569 16 1 16V14ZM19 14V16C20.1046 16 21 15.1046 21 14H19ZM19 1H21C21 -0.10457 20.1046 -1 19 -1V1ZM1 -1C-0.104569 -1 -1 -0.10457 -1 1H1V1V-1Z",
    fill: "#E8E7E4"
  }));
};
export default Israel;
//# sourceMappingURL=Israel.js.map
// @zapier/checkout@7.13.0 (cd15c152f)
